import React from "react";
import * as styles from "./Features.module.scss";
import type { FeatureBlock } from "@shared/arrays/dashly-vs";

/**
 * Four feature sections. The export marked every one of them as an h1; they are
 * h2s here, with the export's own headline kept underneath as copy.
 */
export function Features({ blocks }: { blocks: FeatureBlock[] }) {
  return (
    <>
      {blocks.map((block, i) => (
        <section
          key={block.title}
          className={`${styles.section} ${i % 2 === 1 ? styles.grey : ""}`}
        >
          <div className={styles.inner}>
            <header className={styles.head}>
              <h2 className={styles.heading}>{block.title}</h2>
              <p className={styles.lead}>{block.lead}</p>
            </header>

            <ul className={styles.grid}>
              {block.items.map((item) => (
                <li key={item.title} className={styles.card}>
                  <h3 className={styles.title}>{item.title}</h3>
                  <p className={styles.text}>{item.text}</p>
                </li>
              ))}
            </ul>

            {block.link && (
              <p className={styles.more}>
                <a href={block.link.href}>{block.link.label}</a>
              </p>
            )}
          </div>
        </section>
      ))}
    </>
  );
}

export default Features;
